import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;

  width: 100%;
  height: 100%;

  background-image: url('/images/backgrounds/error-background.png');
  background-position: left;
  background-size: cover;
`;

export const Content = styled.div`
  position: absolute;
  bottom: 25%;
  left: 15%;

  display: flex;
  flex-direction: column;

  span {
    color: #fff;
    font-size: 20px;
    font-weight: 600;
  }

  .big-text {
    font-size: 65px;
    line-height: 55px;
  }

  .margin-bottom {
    margin-bottom: 24px;
  }

  .outline {
    background: #fff;
    color: ${({ theme }) => theme.colors.onBackground};
    border-radius: ${({ theme }) => theme.borderRadius.lg};
    padding: 16px;
    text-align: center;
  }

  @media (max-width: 690px) {
    position: initial;
    align-items: center;
    justify-content: center;

    height: 100%;
    padding: 16px;
  }
`;
